function smoothScroll() {
    function a() {
        if (document.body) {
            var a = document.body,
                b = document.documentElement,
                c = window.innerHeight,
                d = a.scrollHeight;
            if (A = document.compatMode.indexOf("CSS") >= 0 ? b : a, l = a, y = !0, top != self) w = !0;
            else if (d > c && (a.offsetHeight <= c || b.offsetHeight <= c)) {
                var e = !1,
                    f = function() {
                        e || b.scrollHeight == document.height || (e = !0, setTimeout(function() {
                            b.style.height = document.height + "px", e = !1
                        }, 500))
                    };
                if (b.style.height = "", setTimeout(f, 10), g("DOMNodeInserted", f), g("DOMNodeRemoved", f), A.offsetHeight <= c) {
                    var h = document.createElement("div");
                    h.style.clear = "both", a.appendChild(h)
                }
            }
            if (document.URL.indexOf("mail.google.com") > -1) {
                var i = document.createElement("style");
                i.innerHTML = ".iu { visibility: hidden }", (document.getElementsByTagName("head")[0] || b).appendChild(i)
            }
            z || v || (a.style.backgroundAttachment = "scroll", b.style.backgroundAttachment = "scroll")
        }
    }

    function b(a, b, c, d) {
        if (d || (d = 1e3), i(b, c), s) {
            var e = +new Date,
                f = e - D;
            if (t > f) {
                var g = (1 + 30 / f) / 2;
                g > 1 && (g = Math.min(g, u), b *= g, c *= g)
            }
            D = +new Date
        }
        if (B.push({
                x: b,
                y: c,
                lastX: 0 > b ? .99 : -.99,
                lastY: 0 > c ? .99 : -.99,
                start: +new Date
            }), !C) {
            var h = a === document.body,
                j = function() {
                    for (var e = +new Date, f = 0, g = 0, i = 0; i < B.length; i++) {
                        var l = B[i],
                            o = e - l.start,
                            q = o >= n,
                            r = q ? 1 : o / n;
                        p && (r = k(r));
                        var s = l.x * r - l.lastX >> 0,
                            t = l.y * r - l.lastY >> 0;
                        f += s, g += t, l.lastX += s, l.lastY += t, q && (B.splice(i, 1), i--)
                    }
                    h ? window.scrollBy(f, g) : (f && (a.scrollLeft += f), g && (a.scrollTop += g)), b || c || (B = []), B.length ? G(j, a, d / m + 1) : C = !1
                };
            G(j, a, 0), C = !0
        }
    }

    function c(c) {
        y || a();
        var d = c.target,
            e = f(d);
        if (!e || c.defaultPrevented || h(l, "embed") || h(d, "embed") && /\.pdf/i.test(d.src)) return !0;
        var g = c.wheelDeltaX || 0,
            i = c.wheelDeltaY || 0;
        g || i || (i = c.wheelDelta || 0), Math.abs(g) > 1.2 && (g *= o / 120), Math.abs(i) > 1.2 && (i *= o / 120), b(e, -g, -i), c.preventDefault()
    }

    function d(a) {
        l = a.target
    }

    function e(a, b) {
        for (var c = a.length; c--;) E[F(a[c])] = b;
        return b
    }

    function f(a) {
        var b = [],
            c = A.scrollHeight;
        do {
            var d = E[F(a)];
            if (d) return e(b, d);
            if (b.push(a), c === a.scrollHeight) {
                if (!w || A.clientHeight + 10 < c) return e(b, document.body)
            } else if (a.clientHeight + 10 < a.scrollHeight && (overflow = getComputedStyle(a, "").getPropertyValue("overflow-y"), "scroll" === overflow || "auto" === overflow)) return e(b, a)
        } while (a = a.parentNode)
    }

    function g(a, b, c) {
        window.addEventListener(a, b, c || !1)
    }

    function h(a, b) {
        return (a.nodeName || "").toLowerCase() === b.toLowerCase()
    }

    function i(a, b) {
        a = a > 0 ? 1 : -1, b = b > 0 ? 1 : -1, (x.x !== a || x.y !== b) && (x.x = a, x.y = b, B = [], D = 0)
    }

    function j(a) {
        var b, c, d;
        return a *= q, 1 > a ? b = a - (1 - Math.exp(-a)) : (c = Math.exp(-1), a -= 1, d = 1 - Math.exp(-a), b = c + d * (1 - c)), b * r
    }

    function k(a) {
        return a >= 1 ? 1 : 0 >= a ? 0 : (1 == r && (r /= j(1)), j(a))
    }
    var l, m = 150,
        n = 800,
        o = 80,
        p = !0,
        q = 8,
        r = 1,
        s = !0,
        t = 10,
        u = 1,
        v = !1,
        w = !1,
        x = {
            x: 0,
            y: 0
        },
        y = !1,
        z = !0,
        A = document.documentElement,
        B = [],
        C = !1,
        D = +new Date,
        E = {};
    setInterval(function() {
        E = {}
    }, 1e4);
    var F = function() {
            var a = 0;
            return function(b) {
                return b.uniqueID || (b.uniqueID = a++)
            }
        }(),
        G = function() {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || function(a, b, c) {
                window.setTimeout(a, c || 1e3 / 60)
            }
        }();
    g("mousedown", d), g("mousewheel", c), g("load", a)
}
